module.exports = "<!-- <app-post-list></app-post-list> -->\r\n<!-- <app-post-detail></app-post-detail> -->\r\n<router-outlet></router-outlet>"